import type {
  MessageBarTitleSlots as MessageBarTitleBaseSlots,
  MessageBarTitleProps as MessageBarTitleBaseProps,
  MessageBarTitleState as MessageBarTitleBaseState,
} from '@fluentui/react-message-bar';

export type MessageBarTitleSlots = MessageBarTitleBaseSlots;

export type MessageBarTitleProps = MessageBarTitleBaseProps;

export type MessageBarTitleState = MessageBarTitleBaseState;
